import React from 'react';
import MessageCard from '../MessageCard';
import GoogleLogo from './GoogleLogo';
import Stars from './Stars';
import Copy from '../../../../copy/Copy';

const GoogleReviewMessageCard = ({ hidden, rating, googlePlaceLink }) => {
  if (hidden || !rating) return null;
  return (
    <MessageCard>
      <div style={{ display: 'flex', gap: '8px' }}>
        <GoogleLogo />
        <div>
          <div hidden={!googlePlaceLink}>
            <Copy>googleMessage</Copy>
            <a
              style={{
                fontSize: '15px',
                color: 'rgb(66, 133, 244)',
                marginLeft: '3px',
              }}
              href={googlePlaceLink}
              target="_blank"
            >
              <Copy>here</Copy>
            </a>
          </div>
          <span
            hidden={!!googlePlaceLink}
            style={{ fontSize: '15px' }}
            role="link"
            onClick={() => {
              window.open(googlePlaceLink, '_blank').focus();
            }}
          >
            <Copy>googleMessage</Copy>
          </span>
          <div
            style={{
              display: 'flex',
              gap: '8px',
              alignItems: 'center',
              justifyItems: 'center',
              fontSize: '17px',
              marginTop: '4px',
            }}
          >
            <b>{rating}</b>
            <Stars rating={rating} />
          </div>
        </div>
      </div>
    </MessageCard>
  );
};

export default GoogleReviewMessageCard;
